// extracted by mini-css-extract-plugin
export default {"darkTheme":"dark_darkTheme__Gzwp0"};